// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  // serverUrl: 'http://127.0.0.1:6060/'
  serverUrl: 'https://tecgym.app/'
  // serverUrl: 'https://46.51.220.16:443/'
//   serverUrl: 'http://124.109.41.119:6060/'
};
